import React from "react";
import { Spinner, Table } from "react-bootstrap";
import { Loader } from "../../ticketModule/variables/ListingVariables";

const CalcTable = (
	{
		remainingOPD,
		remainingDental,
		remainingParent,
		calculations,
		limitAmount,
		claimedAmountOPD,
		claimedAmountParents,
		claimedDental,
		claimedAmount,
		outStandingBalance,
		totalRemainingAmount,
		secondHalfRemainingAmount,
		medicalCalculations,
		remainingAmount,
		claimedInternetAmount,
		claimedHealthAmount,
		claimedFuelAmount,
		internetButtonActive,
		healthButtonActive,
		fuelButtonActive,
		medicalCalculationLoading,
		otherCalculationLoading,
	},
	props
) => {
	return (
		<Table className="calcTable" responsive>
			<thead className="calcThead">
				{medicalCalculations ? (
					<tr style={{}}>
						<th
							style={{
								borderRadius: "10px 0px 0px 0px",
								borderTop: "none",
							}}
						>
							Month
						</th>
						<th
							style={{
								borderTop: "none",
							}}
						>
							Limit Amount
						</th>
						<th
							style={{
								borderTop: "none",
							}}
						>
							Claimed OPD
						</th>
						<th
							style={{
								borderTop: "none",
							}}
						>
							Claimed Parents
						</th>
						<th
							style={{
								borderTop: "none",
							}}
						>
							Claimed Dental
						</th>
						<th
							style={{
								borderRadius: "0px 10px 0px 0px",
								borderTop: "none",
							}}
						>
							Outstanding Balance
						</th>
					</tr>
				) : (
					<tr>
						<th
							style={{
								borderRadius: "10px 0px 0px 0px",
								borderTop: "none",
							}}
						>
							Month
						</th>
						<th
							style={{
								borderTop: "none",
							}}
						>
							Limit Amount
						</th>
						<th
							style={{
								borderTop: "none",
							}}
						>
							Claimed Amount
						</th>
						<th
							style={{
								borderRadius: "0px 10px 0px 0px",
								borderTop: "none",
							}}
						>
							Outstanding Balance
						</th>
					</tr>
				)}
			</thead>
			<tbody className="calcTbody">
				{medicalCalculationLoading ? (
					<tr>
						<td
							data-toggle="collapse"
							colSpan="20"
							className="noRecordContainer"
						>
							<Loader />
						</td>
					</tr>
				) : medicalCalculations ? (
					medicalCalculations.map((data, index) => {
						const {
							month,
							limitAmount,
							claimedAmountOPD,
							claimedAmountParents,
							claimedDental,
							outStandingBalance,
						} = data;
						return (
							<tr key={index}>
								<td>{month}</td>
								<td>
									{limitAmount &&
										Math.round(
											limitAmount
										).toLocaleString()}
								</td>
								<td>
									{claimedAmountOPD &&
										Math.round(
											claimedAmountOPD
										).toLocaleString()}
								</td>
								<td>
									{claimedAmountParents &&
										Math.round(
											claimedAmountParents
										).toLocaleString()}
								</td>
								<td>
									{claimedDental &&
										Math.round(
											claimedDental
										).toLocaleString()}
								</td>
								<td>
									{outStandingBalance &&
										Math.round(
											outStandingBalance
										).toLocaleString()}
								</td>
							</tr>
						);
					})
				) : otherCalculationLoading ? (
					<tr>
						<td
							data-toggle="collapse"
							colSpan="20"
							className="noRecordContainer"
						>
							<Loader />
						</td>
					</tr>
				) : (
					calculations.map((data, index) => {
						return (
							<>
								{index === 5 && healthButtonActive ? (
									<>
										<tr key={index}>
											<td>{data.month}</td>
											<td>
												{data.limitAmount?.toLocaleString()}
											</td>
											<td>
												{data.claimedAmount?.toLocaleString()}
											</td>
											<td>
												{data.outStandingBalance?.toLocaleString()}
											</td>
										</tr>
										<tr className="table-footerOne">
											<td>Total</td>
											<td>
												{limitAmount?.toLocaleString()}
											</td>
											<td>
												{claimedHealthAmount?.toLocaleString()}
											</td>
											<td>
												{outStandingBalance?.toLocaleString()}
											</td>
										</tr>
										<br />
									</>
								) : (
									<tr key={index}>
										<td>{data.month}</td>
										<td>
											{data.limitAmount?.toLocaleString()}
										</td>
										<td>
											{data.claimedAmount?.toLocaleString()}
										</td>
										<td>
											{data.outStandingBalance?.toLocaleString()}
										</td>
									</tr>
								)}
							</>
						);
					})
				)}
				{medicalCalculations && (
					<tr className="table-footer">
						<td>Total</td>
						<td>
							{limitAmount &&
								Math.round(limitAmount).toLocaleString()}
						</td>
						<td>
							{claimedAmountOPD &&
								Math.round(claimedAmountOPD).toLocaleString()}
						</td>
						<td>
							{claimedAmountParents &&
								Math.round(
									claimedAmountParents
								).toLocaleString()}
						</td>
						<td>
							{claimedDental &&
								Math.round(claimedDental).toLocaleString()}
						</td>
						<td>
							{outStandingBalance &&
								Math.round(outStandingBalance).toLocaleString()}
						</td>
					</tr>
				)}
				{internetButtonActive && (
					<tr className="table-footer">
						<td>Total</td>
						<td>{limitAmount?.toLocaleString()}</td>
						<td>{claimedInternetAmount?.toLocaleString()}</td>
						<td>{outStandingBalance?.toLocaleString()}</td>
					</tr>
				)}
				{healthButtonActive && (
					<tr className="table-footer">
						<td>Total</td>
						<td>
							{secondHalfRemainingAmount?.limitAmount?.toLocaleString()}
						</td>
						<td>
							{secondHalfRemainingAmount?.claimedAmount?.toLocaleString()}
						</td>
						<td>
							{secondHalfRemainingAmount?.outStandingBalance?.toLocaleString()}
						</td>
					</tr>
				)}
				{fuelButtonActive && (
					<tr className="table-footer">
						<td>Total</td>
						<td>{limitAmount?.toLocaleString()}</td>
						<td>{claimedFuelAmount?.toLocaleString()}</td>
						<td>{outStandingBalance?.toLocaleString()}</td>
					</tr>
				)}
				{medicalCalculations ? (
					<tr className="remaining-limit">
						{remainingOPD < 0 && Math.round(remainingOPD) === 0 ? (
							<td colSpan="9">
								<span style={{ fontWeight: "normal" }}>
									Your remaining Medical budget:{" "}
								</span>
								<span className="reimbRemainingLimit">
									{" "}
									{remainingOPD &&
										Math.round(remainingOPD)
											.toLocaleString()
											.substring(1)}
								</span>
							</td>
						) : remainingOPD < 0 ? (
							<td colSpan="9">
								<span style={{ fontWeight: "normal" }}>
									You've exceeded your Medical budget limit
									by:{" "}
								</span>
								<span className="excededLimit">
									{" "}
									{remainingOPD &&
										Math.round(remainingOPD)
											.toLocaleString()
											.substring(1)}
								</span>
							</td>
						) : (
							<td colSpan="9">
								<span style={{ fontWeight: "normal" }}>
									Your remaining Medical budget:{" "}
								</span>
								<span className="reimbRemainingLimit">
									{" "}
									{remainingOPD &&
										Math.round(
											remainingOPD
										).toLocaleString()}
									{/* , */}
								</span>
								,{" "}
								{remainingParent < 0 ? (
									<>
										<span style={{ fontWeight: "normal" }}>
											you've exceeded your Parents budget
											by:{" "}
										</span>
										<span className="excededLimit">
											{remainingParent &&
												Math.round(remainingParent)
													.toLocaleString()
													.substring(1)}
										</span>
									</>
								) : (
									<>
										<span style={{ fontWeight: "normal" }}>
											{" "}
											of which, you can claim for Parents:{" "}
										</span>
										<span className="reimbRemainingLimit">
											{remainingParent &&
												Math.round(
													remainingParent
												).toLocaleString()}
										</span>
									</>
								)}
								{remainingDental < 0 ? (
									<>
										<span style={{ fontWeight: "normal" }}>
											, you've exceeded your Dental budget
											by:{" "}
										</span>
										<span className="excededLimit">
											{remainingDental &&
												Math.round(remainingDental)
													.toLocaleString()
													.substring(1)}
										</span>
									</>
								) : (
									<>
										<span style={{ fontWeight: "normal" }}>
											{" "}
											and for Dental:
										</span>{" "}
										<span className="reimbRemainingLimit">
											{remainingDental &&
												Math.round(
													remainingDental
												).toLocaleString()}
										</span>
									</>
								)}
							</td>
						)}
					</tr>
				) : (
					<tr className="remaining-limit">
						<td colSpan="9">
							{/* <span style={{ fontWeight: "normal" }}>
								Your Remaining Limit:{" "}
							</span>
							<span className="reimbRemainingLimit">
								{remainingAmount?.toLocaleString()}
							</span>{" "} */}
							{remainingAmount < 0 ? (
								<>
									<span style={{ fontWeight: "normal" }}>
										You've exceeded your limit by:{" "}
									</span>
									<span className="excededLimit">
										{remainingAmount &&
											Math.round(remainingAmount)
												.toLocaleString()
												.substring(1)}
									</span>
								</>
							) : (
								<>
									<span style={{ fontWeight: "normal" }}>
										{" "}
										Your remaining limit:
									</span>{" "}
									<span className="reimbRemainingLimit">
										{remainingAmount &&
											Math.round(
												remainingAmount
											).toLocaleString()}
									</span>
								</>
							)}
						</td>
					</tr>
				)}
			</tbody>
		</Table>
	);
};

export default CalcTable;
